import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=5c902552&"
import script from "./CommentItem.vue?vue&type=script&lang=ts&"
export * from "./CommentItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports